import React, {useContext, useEffect, useState}from 'react';
import "../Styles/EditPatientCss.css";
import { submitEditPatientDetails } from "../../../../service/StudyListService";
import { useFormik } from "formik";
import {EditPatientSchema} from "./EditPatientSchema";
import "../../../../index.css";
import Moment from "moment";
import { useTranslation } from "react-i18next";
import EditPatientBody from './EditPatientBody';
import userContext from '../../../../context/users/UserContext';
import ModalHeader from '../../../../components/Modal/ModalHeader';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import ModalMain from '../../../../components/Modal/ModalMain';
import { logAmplitudeEventWithUsernameAndRole } from '../../../../helpers/Amplitude';
import loaderContext from '../../../../context/loader/LoaderContext';
import studylistContext from '../../../../context/studylist/StudylistContext';

const EditPatientModal = (props) => {
  const {ref, setLoaderRunning} = useContext(loaderContext);
  const { setDataQueryState, dataQueryState} = useContext(studylistContext);
    const [patientDetails, setPatientDetails] = useState({});
    const [loadingState, setLoadingState] = useState("");
    const [loading, setLoading] = useState(false);
    const [filterObj, setFilterObj] = useState({});
    const { username } = useContext(userContext);
    //const studyId = 66;
    const studyId = props.studyId;
    const [t] = useTranslation();

    function hideEditPatientModal() {
      props.setShowEditPatientModal(false);
    }

    const formatDate = (date) => {
      var currentDate = Moment(date).local().format("DD-MMM-YYYY");
      return date == "" ? "" : currentDate;
    };


    const editPatientApiPayload = (values) =>{
      return ({
        id : studyId,
        patientName : values.patientName,
        patientId : values.patientId ,
        patientAge : values.age,
        patientSex : filterObj.sex,
        patientBirthdate : filterObj.dob == null ? null : formatDate(filterObj.dob),
        modalityId: filterObj.modality,
        studyDescription : values.studyDescription,
        referringPhysician: values.referringPhysician,
        studyEmergency : filterObj.studyEmergency
      })
    }

    const handleRowUpdateForPatientDetails = (values) => {

      let newIndex = -1;
      let newData = dataQueryState?.data?.rows.filter((row, index) => {
        if (row.id == props.studyId) {
          newIndex = index;
          return true;
        }
        return false;
      });

      setDataQueryState(() => {
        const newValue = {
          ...dataQueryState
        };
        console.log(props.data)
        if(props.data.row.getIsExpanded()) {
          props.data.row.toggleExpanded();
        }
        if(newValue.data.rows[newIndex].patientId != values.patientId) {
          newValue.data.rows[newIndex].priorsCount = 0;
        }
        newValue.data.rows[newIndex].patientName = values.patientName;
        newValue.data.rows[newIndex].patientId = values.patientId;
        if(filterObj?.modalityName){
          newValue.data.rows[newIndex].modality.name = filterObj.modalityName;
        }
        newValue.data.rows[newIndex].patientAge = values.age;
        newValue.data.rows[newIndex].patientSex = filterObj.sex;   
        newValue.data.rows[newIndex].edited = true; 
        if(filterObj.studyEmergency === 3){
          newValue.data.rows[newIndex].emergency = true;
          newValue.data.rows[newIndex].nonMedicalEmergency = true;
        }else if(filterObj.studyEmergency === 2){
          newValue.data.rows[newIndex].emergency = true;
          newValue.data.rows[newIndex].nonMedicalEmergency = false;
        }else if(filterObj.studyEmergency === 1){
          newValue.data.rows[newIndex].emergency = false;
          newValue.data.rows[newIndex].nonMedicalEmergency = false;
        }
        return newValue;
      });
    }


    const {
      values,
      errors,
      handleChange,
      handleSubmit,
    } = useFormik({
      initialValues:  {
        patientName: patientDetails?.patientName,
        patientId: patientDetails.patientId,
        modality: patientDetails.modality,
        age: patientDetails.patientAge,
        sex: patientDetails.patientSex,
        dob: patientDetails.patientBirthdate,
        studyDescription: patientDetails.studyDescription,
        referringPhysician: patientDetails.referringPhysician,
        studyEmergency : patientDetails.studyEmergency
    },
      enableReinitialize: true,
      validationSchema: EditPatientSchema,
      onSubmit: async (values, actions) => {
        console.log("I am here in submit");
        setLoadingState("Update patient details");
        setLoaderRunning(true);
        ref.current.continuousStart();
        setLoading(true);
        const editPatientDto = editPatientApiPayload(values);
        const response = await submitEditPatientDetails(editPatientDto);
        setLoading(false);
        if (response.status === 200 && response.data.result === "SUCCESS") {
          setLoaderRunning(false);
          ref.current.complete();
          let eventProperties = {
            "STUDY ID": studyId,
          };
          logAmplitudeEventWithUsernameAndRole('EVENT_BASIC_CLINICAL_HISTORY_UPLOAD_CLICKED', eventProperties, username);
          handleRowUpdateForPatientDetails(values);
          props.setShowEditPatientModal(false);          
        }
        else{
          setLoaderRunning(false);
          ref.current.complete();
          props.setShowEditPatientModal(false);  
        }
      }
    });

    const handleKeyPress = (event) => {
      console.log("--- Enter is pressed ----");
      if (event.key === "Enter") {
        handleSubmit();
      }
    }

    let PrimaryButtonList = [
      {
          title:t("button.submit"),
          onclick: handleSubmit,
      }
    ];
    let DefaultButtonList = [
      {
          title:t("button.cancel"),
          onclick: hideEditPatientModal
      }
    ];

    const modalDetails = {
      header: <ModalHeader updatedModal={true} patientName={props.patientName} patientID={props.patientId} heading={t("patient.title")} handleCancel={hideEditPatientModal}/>,
      footer : <ModalFooter PrimaryButtonList={PrimaryButtonList} DefaultButtonList={DefaultButtonList} key={props.studyId}/>,
      body : <EditPatientBody handleEnterKeyPress={handleKeyPress} setPatientDetails={setPatientDetails} values={values} handleChange={handleChange} studyId={studyId} setShowEditPatientModal={props.setShowEditPatientModal} filterObj={filterObj} setFilterObj={setFilterObj} errors={errors} reportDoneStatus={props.data.row.original.reportDoneStatus}/>,
      width : "700px"
    }
    
    return (
      <div>
          <ModalMain updatedModal={true} showModal={props.showEditPatientModal} modalDetails={modalDetails}/>
      </div>
    );
  };

export default EditPatientModal